import type { Logger } from '@feature-hub/core';
import type { ContentChangeListener } from '@oneaudi/content-service';
import type {
  ContentService,
  VueFormatterFeatureServiceInterface,
  LocaleService,
} from '../../types/feature-service-types';
import React, { useState } from 'react';
import { ContentContext } from './ContentContext';
import type { EditorJsonContent, FalconContent, TilesContent } from './contentTypes';
import { mapFaceContent, mapHeadlessContent } from './utils/mappers';

export const ContentContextProvider: React.FC<{
  contentService: ContentService;
  vueFormatterService: VueFormatterFeatureServiceInterface;
  logger?: Logger;
  children?: React.ReactNode;
  localeService?: LocaleService;
}> = ({ contentService, vueFormatterService, logger, children, localeService }) => {
  const [content, setContent] = useState(
    contentService.getContent() as FalconContent | EditorJsonContent,
  );
  contentService.onContentChange(setContent as ContentChangeListener);
  let tilesContent: TilesContent;
  if (content.__type === 'aem-headless') {
    logger?.info('aem-headless-content:', content);
    tilesContent = mapHeadlessContent(content);
  } else {
    tilesContent = mapFaceContent(content);
  }

  return (
    <ContentContext.Provider value={{ content: tilesContent, vueFormatterService, localeService }}>
      {children}
    </ContentContext.Provider>
  );
};

ContentContextProvider.displayName = 'ContentContextProvider';
